import { useEffect, useState } from 'react'

export function Embers() {
  const [embers, setEmbers] = useState<number[]>([])

  useEffect(() => {
    // Generate static ember particles
    const newEmbers = Array.from({ length: 60 }, (_, i) => i)
    setEmbers(newEmbers)
  }, [])

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0 bg-gradient-to-t from-[#1a0505] via-[#0c0a09] to-black">
      {/* 1. Blood Fog (Bottom) */}
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-red-950/40 via-transparent to-transparent opacity-60" />

      {/* 2. Rising Ash Particles */}
      {embers.map((i) => (
        <div
          key={i}
          className="absolute w-[4px] h-[4px] bg-red-800/40 animate-ember opacity-0 rounded-full blur-[1px]"
          style={{
            left: `${Math.random() * 100}%`,
            animationDuration: `${10 + Math.random() * 8}s`,
            animationDelay: `${Math.random() * 5}s`,
          }}
        />
      ))}

      {/* 3. Intense Fire Sparks (Battlefield Cinders) */}
      {Array.from({ length: 30 }).map((_, i) => (
        <div
          key={`spark-${i}`}
          className="absolute w-[2px] h-[2px] bg-orange-500 animate-ember-fast opacity-0"
          style={{
            left: `${Math.random() * 100}%`,
            animationDuration: `${3 + Math.random() * 4}s`,
            animationDelay: `${Math.random() * 10}s`,
            boxShadow: '0 0 8px rgba(249, 115, 22, 0.9)',
          }}
        />
      ))}

      {/* 4. Drifting Smoke/Mist (Visual only) */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/ashen.png')] opacity-10 mix-blend-overlay" />
    </div>
  )
}
